import React, { useState } from 'react';
import axios from 'axios';
import { Play, Save, Loader2 } from 'lucide-react';

const API = `${(process.env.REACT_APP_BACKEND_URL || window.location.origin)}/api`;

const WelcomeEditor = ({ settings, onSave }) => {
  const [formData, setFormData] = useState({
    church_name: settings?.church_name || 'CELESTIAL CHURCH OF CHRIST',
    parish_name: settings?.parish_name || 'Valley of Berachah Parish',
    welcome_title: settings?.welcome_title || 'WELCOME TO',
    welcome_subtitle: settings?.welcome_subtitle || 'We welcome you into the presence of the Lord',
    logo_url: settings?.logo_url || '/images/church-logo.png?v=2'
  });
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/display/settings`, formData);
      onSave();
    } catch (error) {
      console.error('Error saving settings:', error);
      alert('Failed to save settings');
    }
    setSaving(false);
  };

  const handleShowWelcome = async () => {
    try {
      await axios.post(`${API}/display/show/welcome`);
      alert('Welcome display activated!');
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-slate-800">Welcome Display</h3>
        <button
          onClick={handleShowWelcome}
          className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700"
        >
          <Play className="w-4 h-4" />
          Show Now
        </button>
      </div>

      <div className="relative aspect-video bg-gradient-to-br from-slate-800 via-blue-900 to-slate-900 rounded-2xl overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-15">
          <img src="/images/church-logo.png?v=2" alt="" className="w-1/3 max-w-[200px] object-contain" />
        </div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-8">
          <p className="text-amber-400 text-xl font-medium mb-2">{formData.welcome_title}</p>
          <h1 className="text-white text-4xl font-bold mb-2">{formData.church_name}</h1>
          <h2 className="text-white/80 text-2xl mb-6">{formData.parish_name}</h2>
          <p className="text-white/60 text-lg italic">"{formData.welcome_subtitle}"</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {[
          { label: 'Welcome Title', key: 'welcome_title' },
          { label: 'Church Name', key: 'church_name' },
          { label: 'Parish Name', key: 'parish_name' },
          { label: 'Subtitle Message', key: 'welcome_subtitle' },
        ].map(field => (
          <div key={field.key}>
            <label className="block text-sm font-medium text-slate-700 mb-1">{field.label}</label>
            <input
              type="text"
              value={formData[field.key]}
              onChange={(e) => setFormData({ ...formData, [field.key]: e.target.value })}
              className="w-full px-4 py-2 border border-slate-200 rounded-xl focus:ring-2 focus:ring-blue-500"
            />
          </div>
        ))}
      </div>

      <button
        onClick={handleSave}
        disabled={saving}
        className="flex items-center gap-2 px-6 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 disabled:opacity-50"
      >
        {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
        Save Changes
      </button>
    </div>
  );
};

export default WelcomeEditor;
